import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../authConfig'

const Singleton = (function () {
	let instance: PublicClientApplication
	let hasInitialized: boolean = false;
	function createInstance() {
		instance = new PublicClientApplication(msalConfig)
		instance.initialize()
		return instance
	}
	return {
		getInstance: function () {
			if (!instance) {
				return createInstance()
			}
			return instance
		},
		initialize: async function () {
			if (!hasInitialized) {
				await instance.initialize()
				await instance.handleRedirectPromise()
				hasInitialized = true
			}
		}
	}
})()
export const msalInstance = Singleton.getInstance()
export const setMsalInstance = () => Singleton.getInstance()
export const initializeMsalInstance = async () => await Singleton.initialize()
